import Api from './Api'

export default {
    all(...args){
        return new Promise(function (resolve, reject) {
            const per_page = args[0]
            const page = args[1]
            const sort = (args[2] ? args[2] : '') //args[2]
            const asc = args[3] ? 1 : 0
            let filters = [] 
            _.forEach(args[4], function(item){
                filters.push('filter_' + item.name + '=' + item.value + '&')
            })
            const query = 'per_page=' + per_page + '&page=' + page + '&sort=' + sort + '&asc=' + asc + '&' + filters.join('')
            Api().get('/api/' + args[5] + '/estimate?' + query).then((response)=>{
                resolve(response.data);
            }).catch((error)=>{
                const obj = (error.response ? {
                    status: error.response.status ? error.response.status : null,
                    statusText: error.response.statusText ? error.response.statusText : null,
                    data: error.response.data ? error.response.data : null,
                    headers: error.response.headers ? error.response.headers : null,
                    obj: error ? error : null
                } : error)
                reject(obj);
            });
        });
    },
    get(company, id){
        return new Promise(function (resolve, reject) {
            Api().get('/api/' + company + '/estimate/' + id).then((response)=>{
                resolve(response.data);
            }).catch((error)=>{
                const obj = (error.response ? {
                    status: error.response.status ? error.response.status : null,
                    statusText: error.response.statusText ? error.response.statusText : null,
                    data: error.response.data ? error.response.data : null,
                    headers: error.response.headers ? error.response.headers : null,
                    obj: error ? error : null
                } : error)
                reject(obj);
            });
        });
    },
    edit(company, id, data){
        return new Promise(function (resolve, reject) {
            Api().put('/api/' + company + '/estimate/' + id, data).then((response)=>{
                resolve(response.data);
            }).catch((error)=>{
                const obj = (error.response ? {
                    status: error.response.status ? error.response.status : null,
                    statusText: error.response.statusText ? error.response.statusText : null,
                    data: error.response.data ? error.response.data : null,
                    headers: error.response.headers ? error.response.headers : null,
                    obj: error ? error : null
                } : error)
                reject(obj);
            });
        });
    },
    add(company, data){
        return new Promise(function (resolve, reject) {
            Api().post('/api/' + company + '/estimate', data).then((response)=>{
                resolve(response.data);
            }).catch((error)=>{
                const obj = (error.response ? {
                    status: error.response.status ? error.response.status : null,
                    statusText: error.response.statusText ? error.response.statusText : null,
                    data: error.response.data ? error.response.data : null,
                    headers: error.response.headers ? error.response.headers : null,
                    obj: error ? error : null
                } : error)
                reject(obj);
            });
        });
    },
    publish(company, id){
        return new Promise(function (resolve, reject) {
            Api().put('/api/' + company + '/estimate/' + id + '/publish', {}).then((response)=>{
                resolve(response.data);
            }).catch((error)=>{
                const obj = (error.response ? {
                    status: error.response.status ? error.response.status : null,
                    statusText: error.response.statusText ? error.response.statusText : null,
                    data: error.response.data ? error.response.data : null,
                    headers: error.response.headers ? error.response.headers : null,
                    obj: error ? error : null
                } : error)
                reject(obj);
            });
        });
    },
    review(company, id){
        return new Promise(function (resolve, reject) {
            Api().post('/api/' + company + '/estimate/' + id + '/review', {}).then((response)=>{
                resolve(response.data);
            }).catch((error)=>{
                const obj = (error.response ? {
                    status: error.response.status ? error.response.status : null,
                    statusText: error.response.statusText ? error.response.statusText : null,
                    data: error.response.data ? error.response.data : null,
                    headers: error.response.headers ? error.response.headers : null,
                    obj: error ? error : null
                } : error)
                reject(obj);
            });
        });
    },
    summary(company, id){
        return new Promise(function (resolve, reject) {
            Api().get('/api/' + company + '/estimate/' + id + '/summary').then((response)=>{
                resolve(response.data);
            }).catch((error)=>{
                const obj = (error.response ? {
                    status: error.response.status ? error.response.status : null,
                    statusText: error.response.statusText ? error.response.statusText : null,
                    data: error.response.data ? error.response.data : null,
                    headers: error.response.headers ? error.response.headers : null,
                    obj: error ? error : null
                } : error)
                reject(obj);
            });
        });
    },
    //
    lines: {
        all(company, id){
            return new Promise(function (resolve, reject) {
                Api().get('/api/' + company + '/estimate/' + id + '/line').then((response)=>{
                    resolve(response.data);
                }).catch((error)=>{
                    const obj = (error.response ? {
                        status: error.response.status ? error.response.status : null,
                        statusText: error.response.statusText ? error.response.statusText : null,
                        data: error.response.data ? error.response.data : null,
                        headers: error.response.headers ? error.response.headers : null,
                        obj: error ? error : null
                    } : error)
                    reject(obj);
                });
            });
        },
        add(company, estimate_id, data){
            return new Promise(function (resolve, reject) {
                Api().post('/api/' + company + '/estimate/' + estimate_id + '/line', data).then((response)=>{
                    resolve(response.data);
                }).catch((error)=>{
                    const obj = (error.response ? {
                        status: error.response.status ? error.response.status : null,
                        statusText: error.response.statusText ? error.response.statusText : null,
                        data: error.response.data ? error.response.data : null,
                        headers: error.response.headers ? error.response.headers : null,
                        obj: error ? error : null
                    } : error)
                    reject(obj);
                });
            });
        },
        edit(company, estimate_id, id, data){
            return new Promise(function (resolve, reject) {
                Api().put('/api/' + company + '/estimate/' + estimate_id + '/line/' + id, data).then((response)=>{
                    resolve(response.data);
                }).catch((error)=>{
                    const obj = (error.response ? {
                        status: error.response.status ? error.response.status : null,
                        statusText: error.response.statusText ? error.response.statusText : null,
                        data: error.response.data ? error.response.data : null,
                        headers: error.response.headers ? error.response.headers : null,
                        obj: error ? error : null
                    } : error)
                    reject(obj);
                });
            });
        },
        editAll(company, estimate_id, data){
            return new Promise(function (resolve, reject) {
                Api().put('/api/' + company + '/estimate/' + estimate_id + '/line', data).then((response)=>{
                    resolve(response.data);
                }).catch((error)=>{
                    const obj = (error.response ? {
                        status: error.response.status ? error.response.status : null,
                        statusText: error.response.statusText ? error.response.statusText : null,
                        data: error.response.data ? error.response.data : null,
                        headers: error.response.headers ? error.response.headers : null,
                        obj: error ? error : null
                    } : error)
                    reject(obj);
                });
            });
        },
        delete(company, estimate_id, id) {
            return new Promise(function (resolve, reject) {
                Api().delete('/api/' + company + '/estimate/' + estimate_id + '/line/' + id).then((response)=>{
                    resolve(response.data);
                }).catch((error)=>{
                    const obj = (error.response ? {
                        status: error.response.status ? error.response.status : null,
                        statusText: error.response.statusText ? error.response.statusText : null,
                        data: error.response.data ? error.response.data : null,
                        headers: error.response.headers ? error.response.headers : null,
                        obj: error ? error : null
                    } : error)
                    reject(obj);
                });
            });
        },
        deleteAll(company, estimate_id, data) {
            return new Promise(function (resolve, reject) {
                Api().delete('/api/' + company + '/estimate/' + estimate_id + '/line', {data: data}).then((response)=>{
                    resolve(response.data);
                }).catch((error)=>{
                    const obj = (error.response ? {
                        status: error.response.status ? error.response.status : null,
                        statusText: error.response.statusText ? error.response.statusText : null,
                        data: error.response.data ? error.response.data : null,
                        headers: error.response.headers ? error.response.headers : null,
                        obj: error ? error : null
                    } : error)
                    reject(obj);
                });
            });
        }
    },
    //
    charges: {
        all(company, id){
            return new Promise(function (resolve, reject) {
                Api().get('/api/' + company + '/estimate/' + id + '/charge').then((response)=>{
                    resolve(response.data);
                }).catch((error)=>{
                    const obj = (error.response ? {
                        status: error.response.status ? error.response.status : null,
                        statusText: error.response.statusText ? error.response.statusText : null,
                        data: error.response.data ? error.response.data : null,
                        headers: error.response.headers ? error.response.headers : null,
                        obj: error ? error : null
                    } : error)
                    reject(obj);
                });
            });
        },
        add(company, estimate_id, data){
            return new Promise(function (resolve, reject) {
                Api().post('/api/' + company + '/estimate/' + estimate_id + '/charge', data).then((response)=>{
                    resolve(response.data);
                }).catch((error)=>{
                    const obj = (error.response ? {
                        status: error.response.status ? error.response.status : null,
                        statusText: error.response.statusText ? error.response.statusText : null,
                        data: error.response.data ? error.response.data : null,
                        headers: error.response.headers ? error.response.headers : null,
                        obj: error ? error : null
                    } : error)
                    reject(obj);
                });
            });
        },
        edit(company, estimate_id, id, data){
            return new Promise(function (resolve, reject) {
                Api().put('/api/' + company + '/estimate/' + estimate_id + '/charge/' + id, data).then((response)=>{
                    resolve(response.data);
                }).catch((error)=>{
                    const obj = (error.response ? {
                        status: error.response.status ? error.response.status : null,
                        statusText: error.response.statusText ? error.response.statusText : null,
                        data: error.response.data ? error.response.data : null,
                        headers: error.response.headers ? error.response.headers : null,
                        obj: error ? error : null
                    } : error)
                    reject(obj);
                });
            });
        },
        delete(company, estimate_id, id) {
            return new Promise(function (resolve, reject) {
                Api().delete('/api/' + company + '/estimate/' + estimate_id + '/charge/' + id).then((response)=>{
                    resolve(response.data);
                }).catch((error)=>{
                    const obj = (error.response ? {
                        status: error.response.status ? error.response.status : null,
                        statusText: error.response.statusText ? error.response.statusText : null,
                        data: error.response.data ? error.response.data : null,
                        headers: error.response.headers ? error.response.headers : null,
                        obj: error ? error : null
                    } : error)
                    reject(obj);
                });
            });
        }
    },
    //
    composto: {
        calcular(company, id, quantity){
            return new Promise(function (resolve, reject) {
                Api().get('/api/' + company + '/composite_product/' + id + '/calculate?quantity=' + quantity).then((response)=>{
                    resolve(response.data);
                }).catch((error)=>{
                    const obj = (error.response ? {
                        status: error.response.status ? error.response.status : null,
                        statusText: error.response.statusText ? error.response.statusText : null,
                        data: error.response.data ? error.response.data : null,
                        headers: error.response.headers ? error.response.headers : null,
                        obj: error ? error : null
                    } : error)
                    reject(obj);
                });
            });
        }
    },
    //
    product: {
        all(company, estimate_id){
            return new Promise(function (resolve, reject) {
                Api().get('/api/' + company + '/estimate/' + estimate_id + '/product_line').then((response)=>{
                    resolve(response.data);
                }).catch((error)=>{
                    const obj = (error.response ? {
                        status: error.response.status ? error.response.status : null,
                        statusText: error.response.statusText ? error.response.statusText : null,
                        data: error.response.data ? error.response.data : null,
                        headers: error.response.headers ? error.response.headers : null,
                        obj: error ? error : null
                    } : error)
                    reject(obj);
                });
            });
        }
    },
    //
    file: {
        delete(company, estimate_id, doc_id){
            return new Promise(function (resolve, reject) {
                Api().delete('/api/' + company + '/estimate/' + estimate_id + '/document/' + doc_id).then((response)=>{
                    resolve(response.data);
                }).catch((error)=>{
                    const obj = (error.response ? {
                        status: error.response.status ? error.response.status : null,
                        statusText: error.response.statusText ? error.response.statusText : null,
                        data: error.response.data ? error.response.data : null,
                        headers: error.response.headers ? error.response.headers : null,
                        obj: error ? error : null
                    } : error)
                    reject(obj);
                });
            });
        }
    }
}


// WEBPACK FOOTER //
// ./resources/js/services/Orcamento.js